import React, {useState} from 'react';
import Product from "../components/Product";
import Cart from "../components/Cart";
import CartButton from "../components/CartButton";
import Header from "../components/UI/Header";
import SideBar from "../components/UI/SideBar";
import BuySubBtnsPanel from "../components/BuySubBntsPanel";
import CheckPoint from "../components/UI/CheckPoint";
import Layout from "../components/Layout/Layout";

const _products = [
    {
        id: 123,
        name: "Abbonamento base",
        price: 96,
        amount: 1,
        trial: false,
        countable: false,
        requirements: [],
        exclusions: [],
    },
    {
        id: 133,
        name: "Abbonamento base - PROVA",
        price: 0,
        amount: 1,
        trial: true,
        countable: false,
        requirements: [],
        exclusions: [123],
    },
    {
        id: 124,
        name: "Abbonamento dinamico + CONSUNTIVI",
        price: 29,
        dailyprice: 0.10,
        amount: 1,
        trial: false,
        countable: false,
        requirements: [123],
        autoAdd: [123],
    },
    {
        id: 124,
        name: "Abbonamento dinamico + CONSUNTIVI - PROVA",
        price: 0,
        dailyprice: 0.10,
        amount: 1,
        trial: true,
        countable: false,
        requirements: [],
        autoAdd: [133],
        exclusions: [124],
    },
    // {
    //     id: 125,
    //     name: "Abbonamento dinamico + CONSUNTIVI",
    //     price: 150,
    //     amount: 1,
    // },
    // {
    //     id: 126,
    //     name: "Abbonamento base + PIASTRELLISTA",
    //     price: 130,
    //     amount: 1,
    // },
    // {
    //     id: 127,
    //     name: "Abbonamento TOTALE",
    //     price: 200,
    //     amount: 1,
    // },
]


const Products = ({...props}) => {

    const [products, setProducts] = useState(_products);

    return (
        <Layout>
            <div
                className="bg-gradient-to-t from-ea_green_from to-ea_green_to w-full h-64 mb-16 flex flex-row justify-around items-center">
                <div>
                    ICONA
                </div>
                <div className="text-left text-white text-2xl">
                    <div className="text-5xl font-bold">edilizi<span className="text-ea_yellow text-6xl">APP</span>
                    </div>
                    <div className="font-bold">Personalizza il tuo abbonamento</div>
                    <div>in base alle tue esigenze</div>
                </div>
            </div>


            <div className="mb-8">
                <div className="text-3xl font-bold mb-4">Abbonamenti annuali</div>
                <div>Scegli e aggiungi i <span className="font-bold">pacchetti</span> che ritieni indispensabili per la
                    gestione della tua
                    attività.
                </div>
            </div>

            <div className="flex flex-col md:flex-row justify-around mb-4 w-full ">
                <div className="relative w-80 overflow-hidden">
                    <div className="head p-2 bg-ea_yellow">
                        <div className="font-bold text-2xl">BASE</div>
                        <div className="uppercase">Pacchetto preventivi</div>
                    </div>

                    <div className="absolute font-bold bg-ea_black text-white top-7 -right-20 rotate-45 w-64 text-sm">
                        PER TUTTI
                    </div>

                    <div className="body bg-ea_gray_soft p-8">
                        <div className="flex flex-col items-center">
                            <div className="flex flex-row justify-start font-bold">
                                <div className="text-xl mr-1">€</div>
                                <div className="text-6xl mr-1">96</div>
                                <div className="text-xl">00</div>
                            </div>
                            <div>Annuali</div>
                        </div>

                        <div className="my-8 text-gray-400">Meno di 2€ a settimana!</div>

                        <div className="flex flex-row justify-center">
                            <a href="#BASE">
                                <div className="p-1 px-4 bg-ea_yellow cursor-pointer">Scopri di più</div>
                            </a>

                        </div>
                    </div>
                </div>

                <div>
                    <div className="head p-2 bg-ea_black text-white">
                        <div className="font-bold text-2xl">DINAMICO</div>
                        <div className="uppercase">Pacchetto consuntivi</div>
                    </div>

                    <div className="body bg-ea_gray_soft p-8">
                        <div className="flex flex-col items-center">
                            <div className="flex flex-row justify-start font-bold">
                                <div className="text-xl mr-1">+</div>
                                <div className="text-6xl mr-1">29</div>
                                <div className="text-xl">00</div>
                            </div>
                            <div>Annuali</div>
                        </div>

                        <div className="my-8 text-gray-400">Aggiunta al pacchetto Base</div>
                        <div className="flex flex-row justify-center">
                            <a href="#Dinamico">
                                <div className="p-1 px-4 bg-ea_black text-white cursor-pointer">Scopri di più</div>
                            </a>
                        </div>
                    </div>
                </div>

            </div>

            <div className="text-ea_green_from my-16 text-2xl">
                <div>Partiamo con la <span className="font-bold">BASE.</span></div>
                <div>Scopri le funzionalità del <span className="font-bold">pacchetto PREVENTIVI</span></div>
            </div>

            <div className="lg:w-2/3">

                <a name="BASE"></a>
                <div className="mb-16">
                    <Header title={"BASE"}
                            subtitle={"Pacchetto preventivi"}/>
                    <div className="flex flex-col-reverse md:flex-row">
                        <SideBar>
                            <CheckPoint>Creazione di preventivi istantanei in meno di 5 minuti</CheckPoint>
                            <CheckPoint>Invio immediato in formato PDF</CheckPoint>
                            <CheckPoint>I tuoi preventivi sempre a portata di mano, all'interno della tua
                                app</CheckPoint>
                            <CheckPoint>Creazione illimitata di preventivi</CheckPoint>
                            <CheckPoint>Salvataggi automatici</CheckPoint>
                            <CheckPoint>Rubrica clienti</CheckPoint>

                            <div className="text-left">... E MOLTO ALTRO</div>
                        </SideBar>
                        <BuySubBtnsPanel product={products[0]}
                                         trialProduct={products[1]}/>
                    </div>
                </div>

                <a name="Dinamico"></a>
                <div className="mb-16">
                    <Header title={"Dinamico"}
                            subtitle={"Pacchetto consuntivi"}
                            className="bg-gray-800 text-white"/>
                    <div className="flex flex-col-reverse md:flex-row">
                        <SideBar>
                            <CheckPoint>Creazione di consuntivi istantanei in meno di 5 minuti</CheckPoint>
                            <CheckPoint>Invio immediato in formato PDF</CheckPoint>
                            <CheckPoint>Trasformazione di un preventivo in un consuntivo in 1 click</CheckPoint>
                            <CheckPoint>Consuntivi aggiornabili giorno per giorno fino alla consclusione del
                                cantiere</CheckPoint>
                            <CheckPoint>Lavorazioni distinguibili per data di esecuzione</CheckPoint>

                            <div className="text-left">... E MOLTO ALTRO</div>
                        </SideBar>
                        <BuySubBtnsPanel product={products[2]}
                                         trialProduct={products[3]}/>
                    </div>
                </div>

                <CartButton/>
            </div>
        </Layout>
    )
}

export default Products;